import { observer } from "mobx-react";
import { FC } from "react";
import {
  CircularProgress,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import { MdError } from "react-icons/md";
import { DeleteIcon } from "../../../../icons";
import { CheckIcon } from "../../../../icons/CheckIcon";
import { useAppStore } from "../../../../../hooks/useAppStore";
import AttachedFileIcon from "../../../../icons/AttachedFile";

const ContactSupportModalFilesDisplay: FC<{ disabled: boolean }> = observer(
  ({ disabled }) => {
    const ErrorIcon = MdError as any;
    const { contactSupportUploadFiles, setContactSupportUploadFiles } =
      useAppStore();

    const FILE_STATES = {
      attached: {
        icon: <DeleteIcon />,
        tooltip: "Remove file",
        color: "error",
      },
      uploading: {
        icon: <CircularProgress size="17px" />,
        tooltip: "File is being uploaded...",
        color: "warning",
      },
      uploaded: {
        icon: <CheckIcon />,
        tooltip: "File uploaded",
        color: "success",
      },
      error: {
        icon: <ErrorIcon size="17px" />,
        tooltip: "Failed to upload",
        color: "error",
      },
    };

    const onRemoveFile = (fileIndex: number) => {
      setContactSupportUploadFiles(
        contactSupportUploadFiles.filter((_, index) => index !== fileIndex),
      );
    };

    return (
      <List dense sx={{ maxHeight: "490px", overflow: "auto" }}>
        {contactSupportUploadFiles?.map((file, fileIndex) => {
          const fileState = FILE_STATES[file.status];

          return (
            <ListItem
              sx={{
                "&:hover": {
                  backgroundColor: "action.hover",
                },
              }}
              key={`${file.file.name}-${fileIndex}`}
              secondaryAction={
                <>
                  {file.status !== "attached" && !disabled ? (
                    <Tooltip
                      arrow
                      title={FILE_STATES.attached.tooltip}
                      placement="right"
                    >
                      <IconButton
                        edge="end"
                        aria-label={FILE_STATES.attached.tooltip}
                        color={FILE_STATES.attached.color as any}
                        onClick={() => onRemoveFile(fileIndex)}
                      >
                        {FILE_STATES.attached.icon}
                      </IconButton>
                    </Tooltip>
                  ) : null}

                  <Tooltip arrow title={fileState.tooltip} placement="right">
                    <IconButton
                      edge="end"
                      aria-label={fileState.tooltip}
                      color={fileState.color as any}
                      onClick={
                        file.status === "attached" && !disabled
                          ? () => onRemoveFile(fileIndex)
                          : undefined
                      }
                    >
                      {fileState.icon}
                    </IconButton>
                  </Tooltip>
                </>
              }
            >
              <ListItemIcon sx={{ minWidth: "35px" }}>
                <AttachedFileIcon />
              </ListItemIcon>
              <ListItemText primary={file.file.name} />
            </ListItem>
          );
        })}
      </List>
    );
  },
);

export default ContactSupportModalFilesDisplay;
